export const SUBNAV_PORTAL_ID = 'subnav-portal-target';



// WEBPACK FOOTER //
// ./src/constants/portals.js